function ibanToString(iban) {
    if (iban === null) return ''

    const str =
        iban.iban01 +
        iban.iban02 +
        iban.iban03 +
        iban.iban04 +
        iban.iban05 +
        iban.iban06 +
        iban.iban07

    return str
}

function stringToIban(str) {
    str = str.replace(/\s/g, '')

    const iban = {
        iban01: str.substring(0, 4),
        iban02: str.substring(4, 8),
        iban03: str.substring(8, 12),
        iban04: str.substring(12, 16),
        iban05: str.substring(16, 20),
        iban06: str.substring(20, 24),
        iban07: str.substring(24, 28),
    }

    return iban
}

export {
    ibanToString,
    stringToIban
}
